var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.646,
    height: 21,
    viewBox: "0 0 19.646 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#758091;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M261.381,274a4.881,4.881,0,1,0,4.922,4.881A4.886,4.886,0,0,0,261.381,274Zm1.5,4.29-1.641,1.969a.615.615,0,0,1-1.023-.119l-.656-1.312a.615.615,0,0,1,1.1-.55l.236.471,1.038-1.246a.615.615,0,1,1,.945.788Z",
    transform: "translate(-246.656 -262.762)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.959,3.5,28.463.923l0,0A3.1,3.1,0,0,0,26.265,0h-7.92A1.848,1.848,0,0,0,16.5,1.846V17.8a1.848,1.848,0,0,0,1.846,1.846h7.891a6.108,6.108,0,0,1,4.988-9.639q.311,0,.615.03V5.659a3.059,3.059,0,0,0-.88-2.154ZM23.021,13.74H19.74a.615.615,0,1,1,0-1.23h3.281a.615.615,0,0,1,0,1.23Zm0-3.281H19.74a.615.615,0,1,1,0-1.23h3.281a.615.615,0,0,1,0,1.23Zm0-3.281H19.74a.615.615,0,1,1,0-1.23h3.281a.615.615,0,0,1,0,1.23Zm3.937,3.281H26.3a.615.615,0,1,1,0-1.23h.656a.615.615,0,1,1,0,1.23Zm0-3.281H26.3a.615.615,0,1,1,0-1.23h.656a.615.615,0,1,1,0,1.23Z",
    transform: "translate(-16.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheck);
export default __webpack_public_path__ + "static/media/file_check.16ce33385deb1b1bdea0989c1f189a9f.svg";
export { ForwardRef as ReactComponent };